// Logged-in app page: clip-pack review grid (routes/PackQa.tsx). Keep keys in sync with
// en/appPackQa.ts.
//
// Sesja 33: werdykt jest ETYKIETĄ 1–3 słów na kadrze, nie zdaniem pod kaflem (zasada 8),
// a stan „cięcie w toku” mówi tytułem z licznikiem plików i paskiem, bez zdania
// „Możesz zamknąć tę stronę”. Kod błędu tego ekranu ma własny prefiks `clip-qa-`,
// żeby pomoc odróżniła go od `clip-pack-` wnętrza paczki (MAPA 33, punkt 17).
export const appPackQa = {
  crumb: {
    packs: 'Klipy',
    review: 'Przegląd',
  },
  tile: {
    aria: 'Klip {n}, {dur}',
  },
  badge: {
    unscreened: 'niesprawdzony',
  },
  blink: {
    label: 'Miganie',
  },
  filter: {
    label: 'Filtr werdyktów',
    all: 'Wszystkie',
    quarantined: 'Do decyzji',
    clean: 'Czyste',
    duplicate: 'Duplikaty',
    unscreened: 'Niesprawdzone',
  },
  item: {
    clip: 'klip',
    lightbox: 'Powiększ klip {n}',
    noFrames: 'brak klatek',
    duplicateOf: 'duplikat · {index}',
    restore: 'Przywróć',
    reject: 'Odrzuć',
  },
  // Powody werdyktu: etykiety, nie zdania.
  reason: {
    credibleText: 'tekst w kadrze',
    cornerOverlay: 'nakładka w rogu',
    phashDuplicate: 'duplikat',
    notChecked: 'niesprawdzony',
    unknown: 'sprawdzamy',
    restoredByUser: 'przywrócony',
  },
  lightbox: {
    position: 'klip {n} z {total}',
    first: 'pierwsza klatka',
    last: 'ostatnia klatka',
    firstShort: 'Pierwsza',
    lastShort: 'Ostatnia',
    frameLabel: 'Która klatka',
    prev: 'Poprzedni klip',
    next: 'Następny klip',
    close: 'Zamknij',
  },
  bulk: {
    restore: 'Przywróć {n}',
    reject: 'Odrzuć {n}',
    delete: 'Usuń {n}',
  },
  progress: {
    cutting: 'Tnę pliki… {done} z {total}',
    notCut: 'nie pocięty',
    unnamedFile: 'plik',
  },
  toast: {
    restored: 'Przywrócono klip {n}.',
    restoredMany_one: 'Przywrócono {n} klip.',
    restoredMany_few: 'Przywrócono {n} klipy.',
    restoredMany_many: 'Przywrócono {n} klipów.',
    restoredMany: 'Przywrócono {n} klipów.',
    rejected: 'Odrzucono klip {n}.',
    rejectedMany_one: 'Odrzucono {n} klip.',
    rejectedMany_few: 'Odrzucono {n} klipy.',
    rejectedMany_many: 'Odrzucono {n} klipów.',
    rejectedMany: 'Odrzucono {n} klipów.',
    restoreFailed: 'Nie udało się przywrócić klipu {n}.',
    rejectFailed: 'Nie udało się odrzucić klipu {n}.',
    undo: 'Cofnij',
  },
  empty: {
    title: 'Nie ma czego przeglądać',
    back: 'Wróć do paczki',
    refunded: 'To jeden ciągły klip',
  },
  error: {
    title: 'Nie udało się wczytać klipów.',
  },
}
